var __jsx = React.createElement;
import React from 'react';
import SAR from "@componentsShared/SAR/SAR";
import { twMerge } from "tailwind-merge";
import { useTranslation } from "@i18n";
import useBoolean from "@hooks/useBoolean";
import useHelpers from "@hooks/useHelpers";
var PricesTable = function PricesTable(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    data = _ref.data,
    _ref$initialDisplayCo = _ref.initialDisplayCount,
    initialDisplayCount = _ref$initialDisplayCo === void 0 ? 4 : _ref$initialDisplayCo,
    onBrandClick = _ref.onBrandClick,
    ctaLink = _ref.ctaLink,
    onBrowseAllClick = _ref.onBrowseAllClick;
  var expansion = useBoolean();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    createUrl = _useHelpers.createUrl;
  var displayedData = expansion.value ? data : data.slice(0, initialDisplayCount);
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var handleBrandClick = function handleBrandClick(link) {
    if (onBrandClick) {
      onBrandClick();
    }
    if (link) {
      navigateTo(link);
    }
  };
  var handleAllPricesClick = function handleAllPricesClick() {
    if (onBrowseAllClick) {
      onBrowseAllClick();
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "self-stretch inline-flex flex-col justify-start items-center gap-5 w-full md:gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "self-stretch flex flex-col justify-start items-end gap-4 md:gap-6"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "self-stretch text-start text-primary-old text-base font-bold md:text-2xl"
  }, title), /*#__PURE__*/React.createElement("div", {
    className: "self-stretch rounded-lg border border-solid border-gray-200 flex flex-col justify-start items-start overflow-hidden shadow-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "self-stretch py-3 bg-blue-50 grid grid-cols-4 md:px-10 md:py-4"
  }, /*#__PURE__*/React.createElement(TableHeadCell, null, tShort("prices/make_model", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement(TableHeadCell, null, tShort("prices/lowest_price", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement(TableHeadCell, null, tShort("prices/highest_price", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement(TableHeadCell, null, tShort("prices/average_price", {
    ns: "web_search"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "self-stretch bg-white"
  }, displayedData.map(function (item, index) {
    return /*#__PURE__*/React.createElement("div", {
      key: item.id,
      className: twMerge("grid grid-cols-4 md:px-10", index !== displayedData.length - 1 && "border-b border-solid border-gray-200")
    }, /*#__PURE__*/React.createElement("a", {
      href: createUrl(item === null || item === void 0 ? void 0 : item.link),
      className: "py-4 inline-flex justify-center items-center gap-2.5 text-primary-old underline text-xs cursor-pointer text-center px-2 md:px-0 md:justify-start md:text-base"
    }, item.brand), /*#__PURE__*/React.createElement(TableBodyCell, null, /*#__PURE__*/React.createElement(TableBodyCellPrice, null, item.lowest), /*#__PURE__*/React.createElement(SAR, {
      className: "text-[#A3AFC0] tex-xs w-4 h-4"
    })), /*#__PURE__*/React.createElement(TableBodyCell, null, /*#__PURE__*/React.createElement(TableBodyCellPrice, null, item.highest), /*#__PURE__*/React.createElement(SAR, {
      className: "text-[#A3AFC0] tex-xs w-4 h-4"
    })), /*#__PURE__*/React.createElement(TableBodyCell, null, /*#__PURE__*/React.createElement(TableBodyCellPrice, null, item.average), /*#__PURE__*/React.createElement(SAR, {
      className: "text-[#A3AFC0] tex-xs w-4 h-4"
    })));
  })))), /*#__PURE__*/React.createElement("a", {
    href: ctaLink.slugify(),
    className: "px-6 py-3 bg-blue-800 hover:bg-blue-900 rounded border border-blue-800 inline-flex justify-center items-center gap-3 transition-colors duration-200 shadow-sm hover:shadow-md cursor-pointer md:min-w-[295px]"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-right text-white text-xs font-bold font-['Cairo'] leading-6 md:text-base"
  }, tShort("prices/show_all", {
    ns: "web_search"
  }))));
};
var TableHeadCell = function TableHeadCell(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "px-2 flex justify-center items-center gap-2.5 md:px-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1 text-center text-primary-old text-xs font-bold whitespace-break-spaces leading-4 md:whitespace-normal md:text-start md:text-base"
  }, children)));
};
var TableBodyCell = function TableBodyCell(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "py-4 inline-flex justify-between gap-1 items-baseline px-3 md:justify-start md:px-0"
  }, children));
};
var TableBodyCellPrice = function TableBodyCellPrice(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "text-center text-gray-text text-xs font-bold leading-6 md:text-base md:min-w-12 md:text-start"
  }, children));
};
export default PricesTable;